import isNil from 'lodash/isNil';

import networkService from '../network-service/network.service';
import { intentDonationDto, paymentDto } from './payment.dto';
import { BillingValues } from '@project/components';
import paymentUrls from './payment.urls';
import { getData } from '../../utils';
import authNetworkService from '../auth-network-service/auth-network.service';

type ExchangeCurrencyType = {
  amount: number;
  amount_currency: string;
  requested_currency: string;
};

const createIntent = (
  eventId?: number | undefined,
  amount?: string,
  currency?: string,
  donationType?: string,
  paymentType?: string,
  prayerRequests?: string,
  tipAmount?: string,
  sponsorMagazine?: string,
  paymentMethod?: string,
) => {
  const url = paymentUrls.createIntentUrl();
  const dto = isNil(eventId)
    ? intentDonationDto({
        amount,
        currency,
        donationType,
        paymentType,
        prayerRequests,
        tipAmount,
        sponsorMagazine,
        paymentMethod,
      })
    : intentDonationDto({
        eventId,
        amount,
        currency,
        donationType,
        paymentType,
        prayerRequests,
        tipAmount,
        sponsorMagazine,
        paymentMethod,
      });

  return networkService.post(url, dto).then(getData);
};
const createRecuringPayment = (
  eventId?: number | undefined,
  amount?: string,
  currency?: string,
  donationType?: string,
  paymentType?: string,
  prayerRequests?: string,
  tipAmount?: string,
  sponsorMagazine?: string,
) => {
  const url = paymentUrls.createSubscriptionUrl();
  const dto = isNil(eventId)
    ? intentDonationDto({
        amount,
        currency,
        donationType,
        paymentType,
        prayerRequests,
        tipAmount,
        sponsorMagazine,
      })
    : intentDonationDto({
        eventId,
        amount,
        currency,
        donationType,
        paymentType,
        prayerRequests,
        tipAmount,
        sponsorMagazine,
      });

  return authNetworkService.post(url, dto).then(getData);
};

const completePayment = (intentId: string, user: BillingValues) => {
  const url = paymentUrls.completePaymentUrl();
  const dto = paymentDto(intentId, user);

  return networkService.post(url, dto).then(getData);
};

const updatePaymentIntent = (intentId: string, nearestBranch: string) => {
  const url = paymentUrls.updatePaymentIntentUrl();

  return networkService
    .post(url, { payment: { id: intentId, nearest_branch: nearestBranch } })
    .then(getData);
};

const exchangeCurrency = (amount: number, amountCurrency: string, requestedCurrency: string) => {
  const url = paymentUrls.exchangeCurrencyUrl(amount, amountCurrency, requestedCurrency);

  return networkService.get(url).then(getData);
};
const multipleExchangeCurrency = (props: {
  tip: ExchangeCurrencyType;
  sponsor_magazine: ExchangeCurrencyType;
}) => {
  const url = paymentUrls.multipleExchangeCurrencyUrl(props);

  return networkService.get(url).then(getData);
};

export default {
  createIntent,
  completePayment,
  exchangeCurrency,
  multipleExchangeCurrency,
  updatePaymentIntent,
  createRecuringPayment,
};
